import { Card, CardContent, Typography } from '@mui/material';

interface NotesDisplayProps {
  notes?: string;
}

export function NotesDisplay({ notes }: NotesDisplayProps) {
  return (
    <Card sx={{ mt: 2 }} id="notes-display">
      <CardContent>
        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600 }}>
          📝 Ghi chú
        </Typography>
        {notes && notes.trim().length > 0 ? (
          <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', color: 'text.secondary' }}>
            {notes}
          </Typography>
        ) : (
          <Typography variant="body2" color="text.disabled" fontStyle="italic">
            Không có ghi chú
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}
